import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { actions, getters } from "../../model";
import Session from "./Session";
import { Text3, Text4 } from "components/Base";
const decorate = connect(
  (state, props) => ({
    selectedsessionsToConvert: getters.selectedsessionsToConvert(state, props),
    data: getters.data(state, props)
  }),
  {
    selectItem: actions.selectItem
  }
);

const Panel = ({ title, children }) => (
  <Div py={3} px={3} bra={1} width={1}>
    <Div mb={2} fw={3}>
      {title}
    </Div>
    {children}
  </Div>
);

const ConvertToSubsessions = ({
  data = {},
  selectedsessionsToConvert = []
}) => {
  return (
    <Div
      style={{ display: "flex", overflowY: "auto", flexDirection: "column" }}
      mb={3}
      width={1}
      height={460}
    >
      <Div py={3} px={3} bra={1} width={1}>
        <Text4 bold width={1}>
          Are you sure you want to convert the selected sessions to subsessions?
        </Text4>
        <Div
          mb={2}
          fw={3}
          mt={2}
          p={5}
          style={{
            backgroundColor: "#eee"
          }}
        >
          <Text3 width={1}>
            Subsessions must start and end within the timeframe of the primary
            session. Once converted, they can only be viewed and managed from
            their primary session.
          </Text3>
        </Div>
      </Div>
      <Panel title="Primary Session">
        <Session session={data} isParentSession={true} />
      </Panel>
      {R.length(selectedsessionsToConvert) > 0 && (
        <Panel title="Subsessions">
          {R.map(
            subSession => (
              <Session session={subSession} />
            ),
            selectedsessionsToConvert
          )}
        </Panel>
      )}
    </Div>
  );
};

export default decorate(ConvertToSubsessions);
